import { ProductConsumerAttributeDto } from '@yiluhub/yilu-amp-types';

import { ParkingProviderId } from 'modules/parking/utils/getParkingDetails';

import { ProductConsumerAttributeRequirement, ProductConsumerAttributeType } from '../../utils';

export enum PARK_AERO_BILLING_ADDRESS_FIELDS {
  STREET = 'street',
  ZIP_CODE = 'zipCode',
  CITY = 'city',
  COUNTRY = 'country',
}

/**
 * NOTE: ANY ADDITION TO THIS LIST SHOULD ALSO BE ADDED TO THE TRANSLATIONS FOR FIELD LABELS
 */
const expectedSortOrder = [
  'company',
  'salutation',
  'title',
  'customer.givenNames',
  'firstName',
  'customer.familyName',
  'lastName',
  'customer.email',
  'email',
  'customer.diallingCode',
  'customer.telephone',
  'customer.mobile',
  'vehicle.registration',
  'customer.address',
  'street',
  'customer.town',
  'city',
  'customer.postcode',
  'zipCode',
  'customer.county',
  'country',
  'loyaltyId',
  'customer.passportNumber',
  'customer.specialRequest',
  'customer.invoiceRequested',
  'customer.companyName',
  'customer.vatNumber',
  'vehicle.make',
  'vehicle.model',
  'vehicle.colour',
  'journeyDetails.outboundFlightNumber',
  'journeyDetails.outboundFlightTime',
  'journeyDetails.returnFlightNumber',
  'journeyDetails.returnFlightTime',
  'journeyDetails.returningFrom',
];

/**
 *  Sort the fields as per the expected ordered array.
 *  NOTE: filter InfoFieldType.COUNTRY as a hack for ParkAero ( we set it manual on submit )
 * @param fields
 */
export const getParkingFieldsToRender = (
  fields: ProductConsumerAttributeDto[],
  providerId?: string,
) => {
  const requiredFields = fields.filter((field) => {
    if (
      providerId === ParkingProviderId.PARK_AERO &&
      (field.name === 'salutation' ||
        field.name === 'company' ||
        field.name === PARK_AERO_BILLING_ADDRESS_FIELDS.COUNTRY ||
        field.name === 'loyaltyId')
    ) {
      return true;
    }

    return (
      field.requirement === ProductConsumerAttributeRequirement.MANDATORY &&
      field.type !== ProductConsumerAttributeType.COUNTRY
    );
  });

  return requiredFields.sort((a, b) => {
    return expectedSortOrder.indexOf(a.name) - expectedSortOrder.indexOf(b.name);
  });
};

export const getParkingSalutationValidationRules = (field: ProductConsumerAttributeDto) => {
  if (field.name === 'salutation') {
    return { required: 'tip.validation.required' };
  }
  return {
    required:
      field.requirement === 'OPTIONAL' ? 'tip.validation.required' : 'tip.validation.optional',
  };
};
